// User menu bar
export const userMenu = [
  {
    name: "Home",
    icon: "fa-solid fa-house-chimney",
    path: "/",
  },
  {
    name: "Appointments",
    icon: "fa-solid fa-calendar-check",
    path: "/appointments",
  },
  {
    name: "Apply Doctor",
    icon: "fa-solid fa-user-doctor",
    path: "/applyDoctor",
  },
  {
    name: "Profile",
    icon: "fa-solid fa-user",
    path: "/user/profile",
  },
];

// Admin Menu Bar
export const adminMenu = [
  {
    name: "Home",
    icon: "fa-solid fa-house-chimney",
    path: "/",
  },
  {
    name: "Users",
    icon: "fa-sharp fa-solid fa-user",
    path: "/admin/users",
  },
  {
    name: "Doctors",
    icon: "fa-solid fa-user-doctor",
    path: "/admin/doctors",
  },
  {
    name: "Profile",
    icon: "fa-solid fa-user",
    path: "/admin/profile",
  },
];
